import React from 'react';

import { MosPosOrderConfirmPage } from '@/pages/externals/mos-pos-resend/detail/MosPosOrderConfirmPage';

/** SCR003 取消確認 */
const MosPosCancelConfirmPage: React.VFC = () => (
  <MosPosOrderConfirmPage mode="cancel" />
);

export default MosPosCancelConfirmPage;
